import * as stylex from "@stylexjs/stylex";
import { colors, spacing } from "@softmax/design-system/tokens.stylex";
import { storefrontSlots, type StorefrontProps } from "./storefront-slots";
export function StoreHeroSplit(props: StorefrontProps) {
  const slots = storefrontSlots({ ...props, splitHero: true });
  return (
    <section data-store-hero="split" {...stylex.props(styles.root)}>
      <div {...stylex.props(styles.lane)}>
        <div {...stylex.props(styles.gridSplit)}>
          <div {...stylex.props(styles.copy)}>
            {slots.header}
            {slots.editor}
          </div>
          <div {...stylex.props(styles.media)}>{slots.media}</div>
        </div>
      </div>
    </section>
  );
}
const styles = stylex.create({
  root: {
    containerType: "inline-size",
    width: "100%",
    backgroundColor: colors.background,
  },
  lane: {
    boxSizing: "border-box",
    width: "100%",
    maxWidth: 1200,
    marginInline: "auto",
    paddingBlock: spacing.space32,
    paddingInline: {
      default: spacing.space32,
      "@media (min-width: 1024px)": {
        default: spacing.space64,
        ":is([data-rail] *)": spacing.space32,
      },
    },
  },
  gridSplit: {
    display: "grid",
    gap: spacing.space32,
    gridTemplateColumns: {
      default: "minmax(0, 1fr)",
      "@container (min-width: 880px)": "minmax(0, 40fr) minmax(0, 60fr)",
    },
    columnGap: {
      default: spacing.space32,
      "@container (min-width: 880px)": spacing.space40,
    },
  },
  copy: {
    display: "flex",
    minWidth: 0,
    flexDirection: "column",
    alignItems: "stretch",
    gap: spacing.space20,
  },
  media: {
    minWidth: 0,
    alignSelf: { default: "stretch", "@container (min-width: 880px)": "start" },
  },
});
